import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IconComponent } from '../icon/icon.component';
import { Icon } from '../../../core/models/icon.model';

@Component({
  selector: 'umkt-account-card',
  standalone: true,
  imports: [RouterModule, IconComponent],
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss'],
})
export class AccountCardComponent {
  @Input() icon?: Icon;
  @Input() title!: string;
  @Input() description!: string;
  @Input() route!: string;
  @Input() badgeCount: number | null = null;

  get showBadge(): boolean {
    return typeof this.badgeCount === 'number' && this.badgeCount > 0;
  }

  get badgeLabel(): string {
    if (!this.showBadge || this.badgeCount === null) {
      return '';
    }
    return this.badgeCount > 99 ? '99+' : String(this.badgeCount);
  }

  get badgeAriaLabel(): string {
    if (!this.showBadge || this.badgeCount === null) {
      return '';
    }
    return this.badgeCount === 1
      ? '1 pedido pendente'
      : `${this.badgeLabel} pedidos pendentes`;
  }
}
